@use "../../../variables" as *;
@use "../../../mixins" as *;

$headerHeight: 5rem;
.detail-container {
  .header-container {
    position: sticky;
    position: -webkit-sticky;
    top: 4rem;
    height: $headerHeight;
    z-index: 1;
    align-self: stretch;
  }

  .product-container {
    display: flex;
    min-height: 35.625rem;

    .images-container {
      flex: 66%;
      display: flex;
      flex-direction: row-reverse;
      flex-wrap: wrap;
      justify-content: space-between;

      > div {
        width: calc(50% - 0.75rem);
        margin-bottom: 1.5rem;

        img,
        video {
          max-width: 23.75rem;
        }
      }

      .image {
        cursor: pointer;
      }
    }

    .info-container {
      flex: 33%;
      margin-left: 1.5rem;
      margin-bottom: 4rem;

      .info-sticky {
        position: sticky;
        position: -webkit-sticky;
        top: $headerHeight;

        .separator {
          @include separator-bottom;
        }

        .like {
          margin-top: 2rem;
          margin-bottom: 2rem;
        }

        .additional-container {
          margin-top: 1rem;
          margin-bottom: 1rem;

          .additional-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: $grey-text;
            font-size: 1.25rem;
            cursor: pointer;
          }

          .toggle-arrow {
            margin-left: auto;
            font-size: 1rem;
          }

          .details {
            margin-top: 1.75rem;
            font-size: 1.125rem;
            display: flex;
            flex-direction: column;
            gap: 0.75rem;
            white-space: pre-wrap;
            .label {
              font-weight: 500;
            }
          }

          .icon {
            justify-self: center;
            margin-left: 0.5rem;
          }

          .epr {
            margin-top: 1.75rem;
            span, a {
              font-weight: 500;
              text-decoration: underline;
              cursor: pointer;
              color: inherit;
            }
          }

          &.disposal-hint {
            .details {
              line-height: 1.375rem;
              margin-right: 2.125rem;
              margin-bottom: 1.375rem;
            }

            .icon {
              font-size: 3rem;
            }

            .additional-title {
              max-height: 1.5rem;
            }
          }
        }

        .buttonContent {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: .5rem;
          
          .active {
            svg {
              fill: $white;
            }
          }
        }
      }
    }
  }

  .matching-products-container {
    margin-top: 4.25rem;
  }
}

.product-not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  .header-container {
    position: sticky;
    position: -webkit-sticky;
    top: 4rem;
    height: $headerHeight;
    z-index: 1;
    align-self: stretch;
  }

  .no-products {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: $white-ter;
    border-bottom-right-radius: 2rem;
    border-bottom-left-radius: 2rem;
    margin-top: 2rem;
    width: 75%;

    .info-text {
      color: $grey-text;
      font-size: 1.5rem;
      text-align: center;
      font-weight: 300;
      padding: 4.5rem;
      line-height: 2.25rem;
    }

    .filter-reset {
      width: 40%;
      margin-top: 0;
      margin-bottom: 5rem;
    }
  }
}
